import { useCallback, useState } from 'react';

import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import { sendWorkspaceDeleteEvent } from 'utils/botUtils';
import logger from 'utils/logging/faro';

const useDeleteWorkspace = () => {
  const { matrixClient } = useMatrixContext();
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteWorkspace = useCallback(
    async (workspaceId: string) => {
      setIsDeleting(true);

      try {
        await sendWorkspaceDeleteEvent(matrixClient, workspaceId).catch((error) => {
          logger.error('Failed to send workspace delete event', { workspaceId, error });
          throw error;
        });

        await matrixClient
          .leave(workspaceId)
          .catch((error) => logger.error('Failed to leave workspace', { workspaceId, error }));
      } finally {
        setIsDeleting(false);
      }
    },
    [matrixClient]
  );

  return { deleteWorkspace, isDeleting };
};

export default useDeleteWorkspace;
